import { render, staticRenderFns } from "./sea-switch.vue?vue&type=template&id=d6b95a1e&"
import script from "./sea-switch.vue?vue&type=script&lang=js&"
export * from "./sea-switch.vue?vue&type=script&lang=js&"
import style0 from "./sea-switch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports